import CarDemo1Container from "../../../home/carDemo1";
import LoginModal from "./LoginModal";
import SignUpModal from "./SignUpModal";

const Login4Container = () => {
  return (
    <>
      <CarDemo1Container />
      <LoginModal />
      <SignUpModal />
    </>
  );
};

export default Login4Container;
